import { createSelector } from '@ngrx/store';

import { onlineMenuState } from '../root';

export const getOnlineMenuPages = createSelector(
    onlineMenuState,
    onlineMenu => onlineMenu?.data?.Pages || null
);
